import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect } from 'react';
import { useGetState } from 'ahooks';
var _event = 'TEAMCONFIG_EVENT';
var _eventKey = 'teamConfig';

function customUserEvent(value) {
  var event = new Event(_event);
  event.key = _eventKey;
  event.newValue = value;
  window.dispatchEvent(event);
}
/**
 * 获取teamConfig信息
 * @function
 */


export var getTeamConfig = function getTeamConfig() {
  return window.teamConfig || {};
};
/**
 * 设置teamConfig信息
 * @function
 */

export var setTeamConfig = function setTeamConfig(data) {
  window.teamConfig = data;
  customUserEvent(data);
};
/**
 * 监听特定事件，当事件触发时调用指定回调函数来处理teamConfig数据
 * @function
 */

export var addTeamConfigEventListener = function addTeamConfigEventListener(eventFn) {
  function _eventFn(e) {
    window.setTimeout(function () {
      eventFn(getTeamConfig(), e);
    });
  } //当前tab页有效


  window.addEventListener(_event, _eventFn);
  return function () {
    window.removeEventListener(_event, _eventFn);
  };
};
/**
 * 管理teamConfig数据状态
 * @function
 */

export var useTeamConfig = function useTeamConfig() {
  var _useGetState = useGetState(getTeamConfig()),
      _useGetState2 = _slicedToArray(_useGetState, 3),
      stateTeamConfig = _useGetState2[0],
      setStateTeamConfig = _useGetState2[1],
      getStateTeamConfig = _useGetState2[2];

  useEffect(function () {
    var removeEventListener = addTeamConfigEventListener(function (newData, e) {
      if (newData !== getStateTeamConfig()) {
        setTeamConfig(newData);
      }
    });
    return function () {
      removeEventListener();
    };
  }, []);
  return stateTeamConfig;
};